module.exports = __webpack_public_path__ + "img/ar.3e963fc8.png";